<template>
  <!-- <v-container fill-height> -->
    <v-row class="justify-center align-center">
      <!-- min-height:200px;max-height:300px; -->
      <v-card color="#0A7EA5" style="min-height:200px;width:100%;" fill-height>
        <v-row class="mt-5 ml-5">
          <v-col cols="12">
        <v-btn text dark type="submit" color="#ffffff" width="100" @click="$router.push(`/login`)">
          <v-icon
        left
        dark
      >
      mdi-chevron-left
      </v-icon>
                Back
              </v-btn>
            </v-col>
            </v-row>
            <v-row class="justify-center align-center text-center ma-2">
              <v-col cols="12">
              <h1 class="white--text">Reset Password</h1>
              </v-col>
            </v-row>
            <v-row class="justify-center align-center text-center ma-2">
              <v-col col="12">
              <h3 class="white--text">Enter your new password</h3>
              </v-col>
            </v-row>
           
      </v-card>
      <v-card style="width:400px;" class="mt-8 ma-2" elevation="0">

            <v-card-title primary-title style="color:#254e58" class="mb-n2">
              <h5>New Password</h5> 
            </v-card-title>
            <!-- Password -->
            <v-card-text>
              <v-text-field
                class="heightsize60"
                name="password"
                id="password"
                v-model="account.password"
                :append-icon="isShowPassword ? 'visibility' : 'visibility_off'"
                @click:append="isShowPassword = !isShowPassword"
                :type="isShowPassword ? 'text' : 'password'"
                outlined
                dense
              />
            </v-card-text>

            <v-card-title primary-title style="color:#254e58; margin-top: -30px;" class="mb-n2">
              <h5>Confirm New Password</h5> 
            </v-card-title>
            <v-card-text>
              <v-text-field
                class="heightsize40"
                name="password"
                id="password"
                v-model="account.confirm_password"
                :append-icon="isShowPassword2 ? 'visibility' : 'visibility_off'"
                @click:append="isShowPassword2 = !isShowPassword2"
                :type="isShowPassword2 ? 'text' : 'password'"
                outlined
                dense
              />
            </v-card-text>

            <v-row class="px-3 pt-8 pb-5 justify-center align-center text-center">
              <v-btn width="150" rounded dark @click="submitData" color="#0A7EA5">
                Confirm
              </v-btn>
            </v-row>
      </v-card>

      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />

      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-row>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import moment from 'moment-timezone';

export default {
  mounted() {
    if (api.isLoggedIn()) {
      this.$router.push("/dashboard");
    }
    
    this.checkDataOtp();
    this.$hideLoader();
  },
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      mainId: 0,
      otpMain: 0,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      isShowPassword: false,
      isShowPassword2: false,
      userId: 0,
      account: {
        password: "",
        confirm_password: "",
      },
    };
  },
  methods: {
    async checkDataOtp(){
      const resOtpcCheck = await api.loadOtpCheck(this.$route.params.id,this.$route.params.com_code)
      if(resOtpcCheck.status == 200){
        var dateNow = moment().tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm:ss");

        // แปลงวันที่เป็น Moment Object
        const momentNow = moment(dateNow, "DD/MM/YYYY HH:mm:ss");
        const momentCheck = moment(resOtpcCheck.data[0].dateCheck, "DD/MM/YYYY HH:mm:ss");

        // คำนวณความแตกต่างในหน่วยชั่วโมง
        const diffInHours = momentNow.diff(momentCheck, 'hours', true);

        if(diffInHours > 1){
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Failed",
            "Please complete the task within 1 hour.",
            "text-h5 red--text text-center",
            "/login"
          );
        }else{
          this.mainId = resOtpcCheck.data[0].id;
          this.otpMain = resOtpcCheck.data[0].otp_number;
        }

      }else if(resOtpcCheck.status == 203){
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Failed",
          "This user does not exist.",
          "text-h5 red--text text-center",
          "/login"
        );
      }else{
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Failed",
          "This user does not exist.",
          "text-h5 red--text text-center",
          "/login"
        );
      }
    },
    async submitData() {

      this.userId = this.mainId;

      if (this.account.password == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input password",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.account.confirm_password == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Confirm Password",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.account.password != this.account.confirm_password) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Password and Confirm Password not match",
          "text-h5 red--text text-center"
        );
        return;
      }

      const res_reset = await api.resetPasswordOtp(this.userId,this.otpMain,this.account);
      // alert(res_reset.status);
      if (res_reset.status == 200 || res_reset.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Success",
          "Update data success",
          "text-h5 green--text text-center",
          "/login"
        );
      } else if(res_reset.status == 203){
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed!!!",
          "Update data Failed, Username not found in the system.",
          "text-h5 red--text text-center"
        );

      }else{
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update data Failed",
          "text-h5 red--text text-center"
        );
      }
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
</script>

<style>
.heightsize60 {
  height: 60px;
}

.heightsize40 {
  height: 40px;
}
</style>

